import { Campaign } from 'src/apis/coupon'
import { Card, IAcceptConsent, MemberLevels, PointHistory } from 'src/apis/profile'

export interface MemberStateInterface {
  availableCard: Card[]
  isLoadingCard: boolean
  isLoadingCampaign: boolean
  isLoadingHistory: boolean
  campaigns: Campaign[]
  history: PointHistory[]
  selectedCampaign: Campaign | null
  currentCard: Card | null,
  memberLevels: MemberLevels[]
  acceptConsent: IAcceptConsent | null
}

function state(): MemberStateInterface {
  return {
    availableCard: [],
    isLoadingCard: false,
    isLoadingCampaign: false,
    isLoadingHistory: false,
    campaigns: [],
    history: [],
    selectedCampaign: null,
    currentCard: null,
    memberLevels: [],
    acceptConsent: null
  }
}

export default state
